import './_tickets.scss';
import './_tickets.dark-mode.scss';
import React, { useEffect, useState, useContext } from 'react';
import { Grid, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { has, pickBy } from 'lodash';
import qs from 'qs';

import Pagination from '../../components/Pagination';
import TableTickets from './components/TableTickets';
import FilterGroup from '../../components/Filters/FilterGroup';
import SearchGroup from '../../components/Search/SearchGroup';
import SearchButton from '../../components/Search/SearchButton';
import Spinner from '../../components/Loaders/Spinner';
import Loader from '../../components/Loaders/Loader';
import ModalsManager from './components/Modals/Manager';

import { generateAccessMassDrop } from './helpers';
import { getTicketsList, getTicketsConfigAction, getTicketsPaginationAction } from '../../redux/actions/tickets';
import { getNavbarCountersAction } from '../../redux/actions/header';
import { clearRootStateAction } from '../../redux/actions/root';
import { getRootStateSelector } from '../../redux/selectors/root';
import { getTicketsListSelector } from '../../redux/selectors/tickets';
import { WebsocketContext } from '../../utils/WebsocketProvider';
import * as actionTypes from '../../redux/types/tickets';

const Tickets = () => {
  const { eventData } = useContext(WebsocketContext);

  const { tickets, config, search_types, filters } = useSelector((state) => getRootStateSelector(state));
  const ticketsState = useSelector((state) => getTicketsListSelector(state));
  const { isFetching, pagination, paginationFetching, staff, staffFetching, statuses } = ticketsState;

  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [unreadBtnText, setUnreadBtnText] = useState('Show unread');
  const [values, setValues] = useState([]);
  const [modal, setModal] = useState({
    openModalKey: null,
    data: {},
  });

  const onHideModals = () => {
    setModal((prevState) => ({
      ...prevState,
      openModalKey: null,
      data: {},
    }));
  };

  const onOpenModal = (openModalKey, data) => {
    setModal({
      openModalKey,
      data,
    });
  };

  const onSubmitModal = () => {
    onHideModals();
    dispatch({
      type: actionTypes.ADD_TICKET_SUCCESS,
    });
  };

  useEffect(() => {
    dispatch(getNavbarCountersAction({ code: 'tickets-list' }));
    setLoading(true);
    Promise.all([dispatch(getTicketsList(queryString)), dispatch(getTicketsConfigAction())])
      .then(() => {
        !init && setInit(true);
        setLoading(false);
        dispatch(getTicketsPaginationAction(queryString));
      })
      .catch(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location]);

  useEffect(() => {
    setValues([]);

    if (queryString.unread) {
      setUnreadBtnText('Show all');
    } else {
      setUnreadBtnText('Show unread');
    }

    document.title = 'Tickets';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(
    () => () => {
      dispatch(clearRootStateAction());
    },
    [dispatch],
  );

  useEffect(() => {
    switch (eventData?.name) {
    case 'menu_counter_update':
      if (eventData?.options?.code === 'tickets-list') {
        dispatch(getTicketsList(queryString, false));
      }
      break;

    default:
      break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventData]);

  const accessMassActions = generateAccessMassDrop(config);

  const showUnread = () => {
    const newQuery = queryString;

    if (newQuery.unread) {
      delete newQuery.unread;
      return history.push(`${location.pathname}?${qs.stringify(newQuery)}`);
    }
    newQuery.unread = 1;
    return history.push(`${location.pathname}?${qs.stringify(newQuery)}`);
  };

  const onSelectStatuses = (options) => {
    if (options?.length === 0 && !has(queryString, 'status')) return;
    const newOptions = options.filter((option) => option.id !== null).map((opt) => opt.id);
    const queryObj = {
      ...queryString,
      status: newOptions,
    };
    if (has(queryObj, 'page')) delete queryObj.page;
    history.push({ pathname: location.pathname, search: qs.stringify({ ...pickBy(queryObj) }) });
  };

  return (
    <Grid fluid>
      <ModalsManager modal={modal} onHide={onHideModals} onSubmit={onSubmitModal} />
      <FilterGroup>
        {config?.access?.create_ticket && (
          <li>
            <Button onClick={() => onOpenModal('add', {})}>Add ticket</Button>
          </li>
        )}
        <SearchGroup autocomplete="on" sectionName="ticket" withSelect options={search_types} placeholder="Search tickets" />
        {config?.access?.unread_ticket && <SearchButton onClickButton={showUnread} buttonText={unreadBtnText} />}
      </FilterGroup>
      {!init && (loading || isFetching) ? (
        <Loader />
      ) : (
        <>
          <TableTickets
            isLoading={loading || isFetching}
            setValues={setValues}
            values={values}
            tickets={tickets}
            accessMassActions={accessMassActions}
            statuses={statuses}
            config={config?.access}
            staff={staff}
            staffFetching={staffFetching}
            filters={filters}
            onSelectStatuses={onSelectStatuses}
          />
          <>
            {paginationFetching ? (
              <div className="pagination">
                <Spinner />
              </div>
            ) : (
              <Pagination
                pages={pagination?.pages}
                currentPage={pagination?.current_page}
                itemsCount={pagination?.total_count}
                pageSize={pagination?.page_size}
                pagesLimit={pagination?.pages < 10 ? pagination?.pages : 10}
              />
            )}
          </>
        </>
      )}
    </Grid>
  );
};

export default Tickets;
